import {
  Chip,
  Text,
  Tooltip,
  ColorsV2,
  useThemeColors,
  Box,
  Flex,
} from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

type PurchasedForChipProps = {
  groupNames?: string[];
};

const PurchasedForChip = ({ groupNames }: PurchasedForChipProps) => {
  const { t } = useTranslation('storefront');
  const [backgroundChipColor, textChipColor] = useThemeColors([
    ColorsV2.SUCCESS_LIGHTEST,
    ColorsV2.SUCCESS_DARK,
  ]);

  if (!groupNames || groupNames.length === 0) {
    return null;
  }

  return (
    <Tooltip
      content={t('purchasedForChip.tooltip', {
        groupNames: groupNames.join(', '),
      })}
      placement="bottom"
      wrapperWidth="100%">
      <Box>
        <Chip
          id="purchased-for-chip"
          variant="small"
          backgroundColor={backgroundChipColor}
          textColor={textChipColor}
          width="fit-content"
          icon="user-group">
          <Flex width="100%" maxWidth="140px">
            <Text variant="legal" color={textChipColor} truncateAt="100%">
              {groupNames[0]}
            </Text>
            {groupNames.length > 1 && (
              <Text variant="legal" color={textChipColor}>
                &nbsp;{`+ ${groupNames.length - 1}`}
              </Text>
            )}
          </Flex>
        </Chip>
      </Box>
    </Tooltip>
  );
};

export default PurchasedForChip;
